import type { RouteSegment } from "$lib/features/route/routeSegment.type";
import { calculateSurfaceStats } from "$lib/utils/geo.util";

export enum RoadSurface {
    PAVED_SMOOTH = 'PAVED_SMOOTH',
    PAVED = 'PAVED',
    PAVED_ROUGH = 'PAVED_ROUGH',
    COMPACTED = 'COMPACTED',
    DIRT = 'DIRT',
    GRAVEL = 'GRAVEL',
    PATH = 'PATH',
    IMPASSABLE = 'IMPASSABLE',
    UNKNOWN = 'UNKNOWN'
}

export const ROAD_SURFACE_COLORS: Record<RoadSurface, string> = {
    [RoadSurface.PAVED_SMOOTH]: '#16a34a',
    [RoadSurface.PAVED]: '#2563eb',
    [RoadSurface.PAVED_ROUGH]: '#f97316',
    [RoadSurface.COMPACTED]: '#ca8a04',
    [RoadSurface.DIRT]: '#78350f',
    [RoadSurface.GRAVEL]: '#64748b',
    [RoadSurface.PATH]: '#d2b48c',
    [RoadSurface.IMPASSABLE]: '#dc2626',
    [RoadSurface.UNKNOWN]: '#a1a1aa'
};

export const ROAD_SURFACE_LABELS: Record<RoadSurface, string> = {
    [RoadSurface.PAVED_SMOOTH]: 'Paved Smooth',
    [RoadSurface.PAVED]: 'Paved',
    [RoadSurface.PAVED_ROUGH]: 'Paved Rough',
    [RoadSurface.COMPACTED]: 'Compacted',
    [RoadSurface.DIRT]: 'Dirt',
    [RoadSurface.GRAVEL]: 'Gravel',
    [RoadSurface.PATH]: 'Path',
    [RoadSurface.IMPASSABLE]: 'Impassable',
    [RoadSurface.UNKNOWN]: 'Unknown'
};

export const PAVED = new Set<RoadSurface>([
    RoadSurface.PAVED_SMOOTH,
    RoadSurface.PAVED,
    RoadSurface.PAVED_ROUGH
]);

export const UNPAVED_LABELS: Partial<Record<RoadSurface, string>> = {
    [RoadSurface.COMPACTED]: 'compacted gravel',
    [RoadSurface.DIRT]: 'dirt',
    [RoadSurface.GRAVEL]: 'gravel',
    [RoadSurface.PATH]: 'trail'
};

export function getSurfaceBreakdown(segments: RouteSegment[]): Record<RoadSurface, number> {
    const surfaceStats = calculateSurfaceStats(segments);
    return surfaceStats.reduce(
        (acc, stat) => {
            acc[stat.surface] = (acc[stat.surface] ?? 0) + stat.percentage;
            return acc;
        },
        {} as Record<RoadSurface, number>
    );
}